const headerEn = {
  brand: 'Grameen Bazar',
  top: {
    bazarList: 'Bazars',
    help: 'Help',
    contact: 'Contact',
  },
  nav: {
    dailyBazar: 'Grocerie',
    medicineBazar: 'Medicine',
    foodBazar: 'Fresh Food',
    grains: 'Grains',
    nationalBazar: 'National',
    garmentsBazar: 'Garments',
    cosmeticsBazar: 'Cosmetics',
    bookBazar: 'Books',
    nurseryBazar: 'Nursery',
    electronicsBazar: 'Electronics',
    chemicalBazar: 'Chemical',
    hardwareBazar: 'Hardware',
    serviceBazar: 'Service',
    feedBazar: 'Animal Feed',
  },
  search: {
    placeholder: 'What are you shopping for?'
  },
  drawer: {
    home: 'Home',
    dailyBazar: 'Daily Bazar',
    medicineBazar: 'Medicine Bazar',
    grains: 'Grains Bazar',
    nationalBazar: 'National Bazar',
    foodBazar: 'Fresh Food',
    bookBazar: 'Book Bazar',
    nurseryBazar: 'Nursery Bazar',
    garmentsBazar: 'Garments Bazar',
    electronicsBazar: 'Electronics Bazar',
    chemicalBazar: 'Chemical Bazar',
    hardwareBazar: 'Hardware Bazar',
    cosmeticsBazar: 'Cosmetics Bazar',
    serviceBazar: 'Service Bazar',
    feedBazar: 'Feed Bazar',
  },
  profileMenu: {
    login: 'Login',
    register: 'Register',
    myAccount: 'My Account',
    storeDashboard: 'Store Dashboard',
    adminDashboard: 'Admin Dashboard',
  },
};

export default headerEn;



